import { useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { GetAccessToken } from "../index";
import { useState } from 'react';
import Placeholder from 'react-bootstrap/Placeholder';
import DataTable from 'react-data-table-component';
import styled from "styled-components";
import { msalConfig } from '../authConfig';
import "./GetReturnsListNil.css";
import { useTheme } from './ThemeContext';
import { Box, CircularProgress } from '@mui/material';
import { useAppConfig } from '../config/AppConfigContext';

export function GetReturnsListNil() {
    const { instance } = useMsal();
    const [List, setList] = useState([]);
    const [globalFilterText, setGlobalFilterText] = useState("");
    const [tableLoadStatus, setTableLoadStatus] = useState(false);
    const { theme } = useTheme();
    const config = useAppConfig();
    const columns = [
        {
            //field: 'organisationCode', headerName: 'Organisation', flex: 1 
            name: "Organisation",
            selector: row => row.organisationCode,
            sortable: true,
            
        },
        {
            //field: 'saleType', headerName: 'Property Type', flex: 1 
            name: "Property Type",
            selector: row => row.saleType,
            sortable: true,
            
        },
        {
            //field: 'salePeriod', headerName: 'Return Period', flex: 1  
            name: "Return Period",
            selector: row => row.salePeriod,
            sortable: true,
            
        },
        {
            //field: 'created', headerName: 'Load Date', flex: 1,
            //renderCell: (params) => {
            //    // Slice the 'created' field to show only the date part (first 10 characters)
            //    return params.value ? params.value.slice(0, 10) : '';
            //} 
            name: "Load Date",
            selector: row => row.created.slice(0,10),
            sortable: true,
        },
        //{
        //    name: "Property Category",
        //    selector: row => row.saleCategory,
        //    sortable: true,
        //},
        //{
        //    name: "Method of Sale",
        //    selector: row => row.saleMethod,
        //    sortable: true,
        //},
        //{
        //    name: "List Price",
        //    selector: row => row.listPrice,
        //    sortable: true,
        //},
        //{
        //    name: "Sale Price",
        //    selector: row => row.salePrice,
        //    sortable: true,
        //},
        //{
        //    name: "Milk Solids",
        //    selector: row => row.milkSolids,
        //    sortable: true,
        //},
        //{
        //    name: "Land Area",
        //    selector: row => row.landArea,
        //    sortable: true,
        //},
        //{
        //    name: "Sale Price/Ha",
        //    selector: row => row.salePrice,
        //    sortable: true,
        //},
        //{
        //    name: "Settlement Date",
        //    selector: row => row.settlementDate,
        //    sortable: true,
        //},
        //{
        //    name: "Status",
        //},
        //{
        //    name: "Errors",
        //},
        //{
        //    name: "Number",
        //    selector: row => row.streetNumber,
        //    sortable: true,
        //},
        //{
        //    name: "Street",
        //    selector: row => row.street,
        //    sortable: true,
        //},
        //{
        //    name: "Suburb",
        //    selector: row => row.suburb,
        //    sortable: true,
        //},
        //{
        //    name: "City",
        //    selector: row => row.townCity,
        //    sortable: true,
        //}

    ];

    const fetchNilReturnsList = async () => {
        //console.log("profile");
        const url = "api/ReturnListNil/GetNilReturnList";
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        const accessToken = await GetAccessToken(tokenRequest);

        try {
            setTableLoadStatus(true);
            await fetch(url,
                {
                    method: "GET",
                    headers: new Headers(
                        {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${accessToken}`
                        }),
                })
                .then((response) => {
                    console.log(response, 'response');
                    if (response.status !== 200 && response.status !== 201) {
                        console.log("not ok" + response.status);
                    }
                    else {
                        return response.json()
                    }
                })
                .then(data => {
                    console.log(data)
                    if (data !== null && data !== undefined) {
                        setList(data);
                    }
                    setTableLoadStatus(false);
                })
                //setIsLoading(false)
                .catch(error => {
                    console.error('Error:', error);
                    setTableLoadStatus(false);
                });
        }
        catch (error) {
            if (error.response) {
                setTableLoadStatus(false);
                console.log(error);
            }
        }
    }
    useEffect(() => {
       fetchNilReturnsList();
    }, []);

    //useEffect(() => {
    //    let timerId = setTimeout(() => {
    //        fetchNilReturnsList();
    //    }, 20000);
    //    return () => {
    //        clearTimeout(timerId)
    //    };

    //}, [List]);

    const handleGlobalFilter = (e) => {
        const value = e.target.value;
        setGlobalFilterText(value);
        fetchNilReturnsList();
    };

    const filteredData = List.filter((row) => {
        return Object.values(row).some((value) =>
            (value || "").toString().toLowerCase().includes(globalFilterText.toLowerCase()));

    });

    const tableCustomStyles = {
        table: {
            style: {
                backgroundColor: theme === 'light' ? '#ffffff':'#000000', 
                color: '#ffffff',
                borderRadius: '8px'
            },
        },
        headCells: {
            style: {
                color: '#ffffff',
                backgroundColor: '#331b8c',
                fontSize: '0.875rem',
                height: '3rem',
            }
        },
        rows: {
            style: {
                backgroundColor: theme === 'light' ? '#ffffff' : '#000000', // Color for row background
                color: theme === 'light' ? '#000000' : '#ffffff', // Text color in rows
                transition: 'background-color 0.3s',
            },
        },
        pagination: {
            style: {
                backgroundColor: '#331b8c', // Footer background color
                color: '#ffffff', // Footer text color
                padding: '10px', // Padding for footer
                borderTop: '2px solid #000', // Border at the top of the footer
                display: 'flex',
                justifyContent: 'center', // Center the pagination
                alignItems: 'center', // Center content vertically in footer
            },
            pageButtonsStyle: {
                // Default state: apply the color to the pagination arrows in normal state
                '& svg': {
                    fill: '#ffffff !important',
                    color: '#ffffff !important',
                },
                '&:hover:not(:disabled)': { // Hover style - change color when button is hovered
                    fill: 'ffffff !important',
                    color: 'ffffff !important'
                },
                '&:focus': { // Focus state: Change color when the button is focused
                    outline: 'none',
                    fill: '#ffffff !important',
                    color: '#ffffff !important'
                },
                // Disabled state: Set color when the pagination arrow is disabled
                '&:disabled': {
                    fill: '#d3d3d3 !important',
                    color: '#d3d3d3 !important',
                }
            },
        },
    }

    return (
        <>
            {/*<div className="container">*/}
            <input className="spacing style" style={{ width: '25rem', marginRight: '1rem', marginLeft: '1rem' }}
                    type="search"
                    id="search"
                    placeholder="Search"
                    value={globalFilterText}
                    onChange={handleGlobalFilter}
                />
            {/*</div>*/}
                <>
                    {tableLoadStatus ? (
                        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
                        <CircularProgress sx={{ color: '#331b8c' }} />
                        </Box>
                    ) :
                        <DataTable
                        columns={columns}
                        data={filteredData}
                        dense
                        pagination
                        highlightOnHover
                        responsive
                        paginationPerPage={50}
                        paginationRowsPerPageOptions={[50, 100, 150]}
                        customStyles={tableCustomStyles}
                        progressPending={tableLoadStatus}>
                        </DataTable>
                }

                </>
           
        </>
    );
}